import { render } from "./EditParameter.vue?vue&type=template&id=23db1ef7"
import script from "./EditParameter.vue?vue&type=script&lang=js"
export * from "./EditParameter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\JOGA\\Desktop\\Projekty\\Trash3\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__